import { isEmbedMode } from "./isEmbedMode";

export type ScrollToStepOptions = {
    skipInitialLoadInEmbed?: boolean;
};

export const scrollToStep = (
    element: HTMLElement | null | undefined,
    options?: ScrollToStepOptions,
): void => {
    if (!element) return;

    if (options?.skipInitialLoadInEmbed && isEmbedMode()) {
        return;
    }

    const scrollMarginTop =
        Number.parseFloat(window.getComputedStyle(element).scrollMarginTop) ||
        0;
    const top =
        element.getBoundingClientRect().top + window.scrollY - scrollMarginTop;
    window.scrollTo({
        top: Math.max(0, top),
        behavior: "smooth",
    });
};

/** Scroll after layout so refs on conditionally rendered sections are available. */
export const scheduleScrollToStep = (
    getElement: () => HTMLElement | null | undefined,
    options?: ScrollToStepOptions,
): void => {
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            scrollToStep(getElement(), options);
        });
    });
};
